"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var DefaultSuggestionsContainer = function DefaultSuggestionsContainer(_ref, paperProps) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_Paper["default"], _extends({
    elevation: 2
  }, paperProps), /*#__PURE__*/_react["default"].createElement("div", containerProps, children));
};

DefaultSuggestionsContainer.propTypes = {
  containerProps: _propTypes["default"].object,
  children: _propTypes["default"].node
};
var _default = DefaultSuggestionsContainer;
exports["default"] = _default;